import { Component, OnInit } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';

import { AuthenicationService } from '../../../_services/authenication.service';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToasterService} from '../../../_services/toaster.service';
import {UserService} from '../../../_services/user.service';
import {first} from 'rxjs/operators';
import {DynamicScriptLoaderServiceService} from '../../../_services/dynamic-script-loader-service.service';

declare var $: any;

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  userdetaild: string;
  usersid: string;
  baseUrl: string = environment.baseUrl;
  editProfForm: FormGroup;
  submitted = false;
  selectedfile: File = null;
  imgtype = 'image/*';
  png = 'image/png';
  jpg = 'image/jpg';
  jpeg = 'image/jpeg';

  imgKey: string = environment.imgKey;
  encodedKey: string;

  // tslint:disable-next-line:max-line-length
  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private authenicationService: AuthenicationService, private toaster: ToasterService, private userservice: UserService, private ng2ImgMax: Ng2ImgMaxService) { }

  ngOnInit() {
    this.encodedKey = btoa(this.imgKey);
    // DynamicScriptLoaderServiceService.adminScripts();
    this.userdetaild = this.authenicationService.userDetails();

    this.editProfForm = this.formBuilder.group({
      users_name: ['', [Validators.required, Validators.minLength(3)]],
      photo: [''],
      users_email: [''],
      users_mobile: ['', [Validators.required]],
      users_city: ['', [Validators.required]]
    });
  }

  get f() { return this.editProfForm.controls; }

  fileUpload(event) {
    let image = event.target.files[0];
    if (image.type === this.jpg || image.type === this.png || image.type === this.jpeg) {
      this.ng2ImgMax.compressImage(image, 1, true).subscribe(
        result => {
          this.selectedfile = result;
        },
        error => {
          console.log(JSON.stringify(error));
          this.toaster.showError('😢 Oh no!', error);
        }
      );

      return true;
    } else {
      this.editProfForm.controls.photo.reset();
      this.toaster.showError('File Type', 'Only Images are allowed');
      return false;
    }
  }

  editForm(data: any) {
    // console.log(data.docid.users_name);
    this.usersid = data._id;
    this.editProfForm.setValue({
      users_name: data.users_name,
      users_email: data.users_email,
      users_mobile: data.users_mobile,
      photo: '',
      users_city: data.users_city
    });

  }

  onSubmit() {
    // stop here if form is invalid
    if (this.editProfForm.invalid) {
      return;
    }
    const addUserPayload = {
      users_name: this.editProfForm.controls.users_name.value,
      users_mobile: this.editProfForm.controls.users_mobile.value,
      users_city: this.editProfForm.controls.users_city.value,
    };

    const formdata = new FormData();

    formdata.append('users_name', addUserPayload.users_name);
    formdata.append('users_mobile', addUserPayload.users_mobile);
    formdata.append('users_city', addUserPayload.users_city);
    formdata.append('users_id', this.usersid);
    if (this.selectedfile !== null) {
      formdata.append('photo', this.selectedfile);
    }

    // console.log(formdata.getAll('photo'));
    this.updateProfile(formdata);
  }

  updateProfile(payload) {
    this.userservice.updateProfile(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            localStorage.setItem('userDetails', btoa(JSON.stringify(data.userData)));
            localStorage.setItem('JWT_TOKEN', data.jwt);
            localStorage.setItem('REFRESH_TOKEN', data.refreshToken);
            this.userdetaild = this.authenicationService.userDetails();
            this.router.navigate(['/profile']);
            //this.toaster.showSuccess('Update Profile', data.ResponseMessage);
            $('#ordine').modal('hide');
          } else {
            this.toaster.showError('Update Profile', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Update Profile', error.error.ResponseMessage);
        });
  }

}
